import { gql, useMutation } from '@apollo/client';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';
import { useDispatch } from 'react-redux';
import { TOAST_ACTIONS } from '../constants';
import { usePlacementsManageContext } from '../context/PlacementsManageContext';
import { FetchPlacementsQuery } from './useQueryPlacements';

export const archivePlacementMutation = gql`
  mutation ArchivePlacement($id: Long!) {
    archivePlacement(id: $id)
  }
`;

export const useArchivePlacement = () => {
  const { placementToArchive, closeArchiveModal } = usePlacementsManageContext();
  const dispatch = useDispatch();
  const [archivePlacement, { error, loading }] = useMutation(archivePlacementMutation, {
    onCompleted: (result) => {
      if (!result?.archivePlacement) {
        dispatch(
          addNegativeToastWithErrorId(
            `Placement ${
              placementToArchive?.placementName || ''
            } could not be archived. Try again.`,
            TOAST_ACTIONS.archivePlacement,
          ),
        );
      } else {
        dispatch(
          addPositiveToast(
            `Placement ${placementToArchive?.placementName || ''} was successfully archived.`,
          ),
        );
      }
      closeArchiveModal();
    },
    onError: (e) => {
      dispatch(
        addNegativeToastWithErrorId(
          `Placement ${placementToArchive?.placementName || ''} could not be archived. Try again.`,
          TOAST_ACTIONS.archivePlacement,
          e,
        ),
      );
      closeArchiveModal();
    },
    refetchQueries: [
      {
        query: FetchPlacementsQuery,
        variables: {
          nonArchivedOnly: false,
        },
      },
    ],
  });

  return {
    archivePlacement,
    error,
    loading,
  };
};
